import styled from '@emotion/styled';
import React from 'react';
import Person04Img from 'ui/images/article/person_04.png';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const HighlightText = styled.span`
    font-weight: 600;
    color: #ee793f;
    background-color: #fffbc9;
`;

const ContentWrapper = styled.div`
    position: relative;
    width: 90%;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    cursor: pointer;
`;

export const MaForBeginnerDerail_3_1: React.FC = () => {
    return (
        <>
            <DescriptionText>
                「MAny」は、 <HighlightText>M&A仲介会社を比較・検討するためのプラットフォーム</HighlightText>
                です。まずは企業情報を登録し、M&Aに関する不安や疑問点などを匿名で投稿します。その後、複数の仲介会社から提案を受け取ることができ、料金体系やサポート内容を比較検討できます。マッチング成立まで企業名などは開示されず、従業員や取引先に知られることなく安心して準備を進められます。
                <HighlightText>初めての方でも登録は簡単で、数分程度で完了</HighlightText>できます。
            </DescriptionText>
            <ContentWrapper
                onClick={() => {
                    window.open('/send-registration-mail/', '_blank');
                }}
            >
                <img src={Person04Img} alt="M&Aの流れ" style={{ width: '100%', height: 'auto' }} />
            </ContentWrapper>
        </>
    );
};
